import { cn } from "@/lib/utils";

const STATUS_MAP = {
  success: { label: "On Track", cls: "bg-[#16A34A]/10 text-[#15803D] ring-[#16A34A]/20" },
  warning: { label: "At Risk", cls: "bg-[#E0A82E]/15 text-[#A16207] ring-[#E0A82E]/30" },
  error: { label: "Blocked", cls: "bg-[#FB6F5A]/12 text-[#C2410C] ring-[#FB6F5A]/30" },
  info: { label: "Planned", cls: "bg-[#1D4ED8]/10 text-[#1D4ED8] ring-[#1D4ED8]/20" },
  neutral: { label: "Draft", cls: "bg-[#EEF2FB] text-[#5A6B8C] ring-[#DCE3F2]" },
  critical: { label: "Critical", cls: "bg-[#DC2626]/12 text-[#B91C1C] ring-[#DC2626]/30" },
};

export const StatusBadge = ({ status = "neutral", label, className, ...props }) => {
  const cfg = STATUS_MAP[status] || STATUS_MAP.neutral;
  return (
    <span
      data-testid={props["data-testid"] || `status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.1em] ring-1 ring-inset",
        cfg.cls,
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label || cfg.label}
    </span>
  );
};
